// src/index.js → Entry point

import "./styles/main.css";
import { initController } from "./ui/controller";

// ----------------------
// 🔹 INIT APP
// ----------------------
initController();
